
import requests from "./httpService";


const SalesServices = {
  getAllSales: async (body) => {
    // console.log(body)
    return requests.post(`/sales/`,body);
  },
  addPayment: async(body)=>{
    // console.log(body)
    return requests.post(`/sales/addPayment`,body)
  },
  getSalesByClientAgent: async(id)=>{
    // console.log(body)
    return requests.get(`/sales/${id}`)
  },
    updateSales: async(id,body)=>{
    // console.log(body)
    return requests.put(`/sales/${id}`,body)
  }
  ,
    getSalesById: async(id)=>{
    // console.log(body)
    return requests.get(`/sales/client/${id}`)
  }
    ,
    getRefundById: async(id)=>{
    // console.log(body)
    return requests.get(`/sales/refund/${id}`)
  },
  updateSellingPrice: async (id, body) => {
  return requests.put(`/sales/price/${id}`, body);
},

};

export default SalesServices;
